import Swal from "sweetalert2";
import { StatusChip } from "../common/StatusChip";

export const getCategoryColumns = (columnHelper, openModalForEdit, toggleCategory,role) => [
  columnHelper.accessor("name", {
    header: "Nombre",
    cell: (info) => <strong>{info.getValue()}</strong>,
  }),

  columnHelper.display({
    id: "status",
    header: "Estado",
    cell: (props) => {
      const status = props.row.original.status;
      return (
        <StatusChip tone={status ? "success" : "danger"}>
          {status ? "Activo" : "Inactivo"}
        </StatusChip>
      );
    },
  }),

  columnHelper.accessor("created_at", {
    header: "Fecha de creación",
    cell: (info) => {
      const raw = info.getValue();
      return raw ? new Date(raw).toLocaleDateString() : "-";
    },
  }),

  columnHelper.display({
    id: "acciones",
    header: "Acciones",
    cell: (props) => {
      const category = props.row.original;
      const isActive = category.status;
      const toggleClass = isActive ? "ui-icon-btn ui-icon-btn--danger" : "ui-icon-btn ui-icon-btn--accent";
      const toggleIcon = isActive ? "ri-forbid-line" : "ri-checkbox-circle-line";
      const toggleText = isActive ? "Inactivar" : "Activar";

      const handleToggle = () => {
        Swal.fire({
          title: `¿Quieres ${toggleText.toLowerCase()} esta categoría?`,
          text: `Categoría: ${category.name}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: isActive ? "#d33" : "#3085d6",
          cancelButtonColor: "#6c757d",
          confirmButtonText: `Sí, ${toggleText}`,
          cancelButtonText: "Cancelar",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await toggleCategory({ id: category.id });
          }
        });
      };

      return (
        <div className="d-flex gap-2 justify-content-end">
          <button
            type="button"
            className="ui-icon-btn"
            onClick={() => openModalForEdit(category)}
            disabled={role === "ASSISTANT"}
            title="Editar"
          >
            <i className="ri-edit-line" />
          </button>

          <button
            type="button"
            className={toggleClass}
            onClick={handleToggle}
            disabled={role === "ASSISTANT"}
            title={toggleText}
          >
            <i className={toggleIcon} />
          </button>
        </div>
      );
    },
  }),
];
